module.exports = __webpack_public_path__ + "static/media/WorkingHours.da777aae.svg";